/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable newline-after-var */
/* eslint-disable max-len */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { toUsMoneyFormat } from '/client/src/utils/amountTransformation';
import { CTooltip, CTooltipLabel, CTooltipText } from './../../components/tooltip/';
import { parseResponse } from '/client/src/pages/Events/detail/listView/helper';
import { convertToLocalTime } from '/client/src/utils/jstz';
import { currency } from '/client/src/constants/';

import _ from 'lodash';

type PropsType = {
  type?: string,
  id?: string,
  image_url?: string,
  image_crop_info?: {
    x1: number,
    x2: number,
    y1: number,
    y2: number
  },
  name?: string,
  location?: string,
  begin_time_utc?: string,
  end_time_utc?: string,
  time_zone_id?: string,
  collaboratorsList?: [],
  is_set_tickets_total_capacity?: boolean,
  tickets_total_capacity?: number,
  transactions?: {
    [string]: string | number | null
  },
  permission?: string
};

class EventCard extends React.PureComponent<PropsType> {
  constructor(props: PropsType) {
    super(props);

    this.state = {
      totalPayed: 0
    };
  }

  componentDidMount() {
    this.setTotalPayed();
  }

  componentDidUpdate() {
    this.setTotalPayed();
  }

  setTotalPayed = () => {
    const { transactions } = this.props;

    const totalPayed = (_.get(transactions, 'merchant_revenue', 0) - _.get(transactions, 'merchant_revenue_refund', 0)) / 100;

    if (!_.isNaN(totalPayed)) {
      this.setState({ totalPayed });
    }
  }

  render(): React.Element<'div'> {
    const {
      type,
      id,
      image_url,
      image_crop_info,
      name,
      location,
      begin_time_utc,
      end_time_utc,
      time_zone_id,
      collaboratorsList,
      transactions,
      is_set_tickets_total_capacity,
      tickets_total_capacity,
      status,
      permission
    } = this.props;

    const isReadonlyPermission = permission === 'Read';
    const startTime = begin_time_utc ? convertToLocalTime(begin_time_utc, time_zone_id, 'MMM Do, h:mm A') : '';
    const endTime = end_time_utc ? convertToLocalTime(end_time_utc, time_zone_id, 'MMM Do, h:mm A z') : '';

    const {
      sold_quantity,
      quantity_expected,
      merchant_ticket_revenue,
      merchant_revenue_expected
    } = parseResponse(transactions, is_set_tickets_total_capacity, tickets_total_capacity);

    const x1 = _.get(image_crop_info, 'x1', 0);
    const x2 = _.get(image_crop_info, 'x2', 0);
    const y1 = _.get(image_crop_info, 'y1', 0);
    const y2 = _.get(image_crop_info, 'y2', 0);

    if (type === 'new-event') {
      return (
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ minHeight: '300px' }}>
          <Link
            to='/events/new'
            className="event-panel event-add"
            style={{
              position: 'absolute',
              top: 0,
              left: '15px',
              width: 'calc(100% - 30px)'
            }}
          >
            <div className="event-image">
              <div className="image">
                <div
                  className="img"
                />
              </div>
            </div>
            <div className="event-info">
              <div className="btn-new">
                <div className="icon-add">
                  <i className="icon icon-plus-circle" style={{ fontSize:'48px' }} />
                </div>
                <span>new event</span>
              </div>
            </div>
            <div style={{
              'display':'block',
              'height':'50px',
              'overflow':'hidden',
              'padding':'0 10px 10px'
              }}
            />
          </Link>
        </div>
      );
    }

    const imageUrlParams = `maxwidth=3200&maxheight=3200&crop=(${encodeURIComponent(`${x1},${y1},${x2},${y2}`)})&width=480`;
    const isGrayFilterClass = (new Date(end_time_utc).getTime() - new Date().getTime()) < 0 || status === 'Close' || status === 'Archive';

    return (
      <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
        <div className={`event-panel md-effect-11 md-hover ${isGrayFilterClass ? 'filter-gray' : ''}`}>
          <div className="event-image">
            <div className="image">
              <div
                className='img'
                style={{
                  backgroundImage: `url("${image_url}?${imageUrlParams}")`
                }}
              />
            </div>

            <div className="event-title">
              <span title={name}>{name}</span>
            </div>

            <div className="event-operation md-content">
              <div className="lt">
                <Link to={`/events/${id}/stats`}><span>stats</span></Link>
              </div>
              <div className="rt">
                <Link to={`/events/${id}/manage`}>
                    <span>manage</span>
                </Link>
              </div>
              <div className="lb">
                {
                  isReadonlyPermission ?
                  <Link to={`/events/${id}/design`}><span>detail</span></Link>
                  :
                  <Link to={`/events/${id}/edit`}><span>edit</span></Link>
                }
              </div>

              <div className="rb">
                <Link to={`/events/${id}/clone`}><span>clone</span></Link>
              </div>
            </div>
          </div>

          <div className="event-info">
            <div className="event-message event-addr">
              <i className="icon icon-location" />
              <span title={location}>{location}</span>
            </div>

            <div className="event-message event-time">
              <i className="icon icon-clock-o" />
              <span>{startTime} - {endTime}</span>
            </div>

            <div className="event-soldinfo row">
              <div className="col-xs-9 left">
                <div className="progress progress-tickets">
                  <div
                    className="progress-bar progress-bar-warning"
                    style={{
                      width: `${sold_quantity * 100 / quantity_expected}%`
                    }}
                  />
                </div>
                <span>
                   {sold_quantity ? sold_quantity : '0' } / {quantity_expected} tickets sold
                </span>
              </div>

              <div className="col-xs-3 right">
                <div>
                  <div className="progress progress-money rotate-270">
                    <div
                      className="progress-bar progress-bar-danger"
                      style={{ width: `${((merchant_ticket_revenue / merchant_revenue_expected) * 100)}%` }}
                    />
                    <div className="money-symbol">
                      <i className="icon icon-usd" />
                    </div>
                  </div>
                  <span>
                    <span className="symbol">{transactions && currency[transactions.currency || 'USD']}</span>
                    <span
                      className="amount"
                      // eslint-disable-next-line
                      title={`${transactions ? (transactions.merchant_revenue - transactions.merchant_revenue_refund) / 100 : ''}`}
                    >
                      {(this.state.totalPayed)}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div style={{ display:'block', height:'50px', padding:'0 10px 10px' }}>
            <div className="event-users">
              <div>
                <div className="event-user-items">
                  {!_.size(collaboratorsList) ?
                    <span>loading...</span> :
                    null
                  }
                  {_.map(collaboratorsList, (ci: {}, ck: number): React.Element<'div'> => {
                    if (ck <= 2) {
                      return (
                        <div
                          key={`collaboratorsList-${ck}`}
                          className="event-user-item"
                          title={`${ci.first_name[0]} ${ci.last_name[0]}`}
                        >
                          <Link
                            to={{ pathname: `/events/${this.props.id}/manage/collaborators` }}
                          >
                            <CTooltip>
                              <CTooltipLabel>
                                <i>{ci.first_name[0]}{ci.last_name[0]}</i>
                              </CTooltipLabel>
                              <CTooltipText>{ci.first_name} {ci.last_name}</CTooltipText>
                            </CTooltip>
                          </Link>
                        </div>
                      );
                    }
                  })}

                  {_.size(collaboratorsList) > 3 ?
                    <div
                      className="event-user-item"
                      title={`+ ${_.size(collaboratorsList) - 3}`}
                    >
                      <Link
                        to={{ pathname: `/events/${this.props.id}/manage/collaborators` }}
                      >
                        <i>{`+ ${_.size(collaboratorsList) - 3}`}</i>
                      </Link>
                    </div> : null
                  }
                </div>
              </div>

              <div className="event-user-more">
                <div className="event-user-item">
                  <Link
                    to={{ pathname: `/events/${this.props.id}/manage/collaborators` }}
                    style={{
                      color: 'inherit',
                      '&:hover': {
                        textDecoration: 'none'
                      }
                    }}
                  >
                    <i className="icon icon-share3" style={{ fontSize:'18px', verticalAlign: 'middle' }} />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

EventCard.defaultProps = {
  begin_time_utc: null,
  end_time_utc: null,
  transactions: {
    sold_quantity: '-',
    ticket_quantity_expected: '-',
    amount: '-',
    merchant_revenue: '-'
  }
};

export default EventCard;
